<template>
  <div class="item-create">
    <ModalSuccessItemCreate v-show="showModalSuccessItemCreate" :show="showModalSuccessItemCreate" @close="showModalSuccessItemCreate = !showModalSuccessItemCreate"></ModalSuccessItemCreate>
    <HeaderMain></HeaderMain>
    <div class="container container-padding">
      <h1 class="heading-top">Annonsera på Gluo &ndash; Just nu helt gratis!</h1>
    </div>
    <main class="wrapper">
      <div class="container">
        <div class="page">
          <div class="form-alert" v-if="responseError">
            <span class="alert alert-error">
              <i class="fas fa-times"></i>Ett fel inträffade
            </span>
          </div>
          <div class="form-alert" v-if="Object.keys(errors).length">
            <span class="alert alert-error">
              <i class="fas fa-times"></i>Fel upptäcktes! Kontrollera de rödmarkerade fälten och försök igen.
            </span>
          </div>
          <form class="form-main" novalidate @submit.prevent="validate()">
            <fieldset class="fieldset-reset form-main-fieldset">
              <div class="form-main-label">
                <label for="title">Rubrik</label>
                <span class="form-main-label-info">("Säljes" behöver inte skrivas)</span>
                <span class="form-main-label-error" v-show="errors.title">{{ errors.title }}</span>
              </div>
              <div class="form-main-input">
                <input type="text" id="title" maxlength="50" :class="{error: errors.title}" v-model.trim="form.title">
              </div>
              <div class="form-main-label">
                <label for="description">Beskrivning</label>
                <span class="form-main-label-error" v-show="errors.description">{{ errors.description }}</span>
              </div>
              <div class="form-main-input">
                <textarea id="description" rows="5" maxlength="3000" :class="{error: errors.description}" v-model.trim="form.description"></textarea>
              </div>
              <div class="form-main-label">
                <label for="price">Pris</label>
                <span class="form-main-label-error" v-show="errors.price">{{ errors.price }}</span>
              </div>
              <div class="form-main-input">
                <div class="input-append">
                  <input type="tel" id="price" maxlength="8" :class="{error: errors.price}" v-model.trim="form.price">
                  <div class="input-addon">
                    <span>kr</span>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset class="fieldset-reset form-main-fieldset">
              <div class="form-main-label">
                <label for="subcategory-id">Kategori</label>
                <span class="form-main-label-error" v-show="errors.subcategoryId">{{ errors.subcategoryId }}</span>
              </div>
              <div class="form-main-input">
                <div class="select-wrapper">
                  <select id="subcategory-id" :class="{error: errors.subcategoryId}" v-model="form.subcategoryId">
                    <option value="">&ndash; Välj kategori &ndash;</option>
                    <optgroup v-for="(category, index) in categories" :key="index" :label="category.name">¨
                      <option v-for="(subcategory, index) in subcategories[category.id - 1]" :key="index" :value="subcategory.id.toString()">{{ subcategory.name }}</option>
                    </optgroup>
                  </select>
                </div>
              </div>
              <div class="form-main-label">
                <label for="region-id">Län</label>
                <span class="form-main-label-error" v-show="errors.regionId">{{ errors.regionId }}</span>
              </div>
              <div class="form-main-input">
                <div class="select-wrapper">
                  <select id="region-id" :class="{error: errors.regionId}" v-model="form.regionId">
                    <option value="">&ndash; Välj län &ndash;</option>
                    <option v-for="(region, index) in regions" :key="index" :value="region.id.toString()">{{ region.name }}</option>
                  </select>
                </div>
              </div>
              <transition name="transition-fade">
                <div v-show="form.regionId && form.regionId != 3">
                  <div class="form-main-label">
                    <label for="area-id">Kommun</label>
                    <span class="form-main-label-error" v-show="errors.areaId">{{ errors.areaId }}</span>
                  </div>
                  <div class="form-main-input">
                    <div class="select-wrapper">
                      <select id="area-id" :class="{error: errors.areaId}" v-model="form.areaId">
                        <option value="">&ndash; Välj kommun &ndash;</option>
                        <option v-for="(area, index) in areas[form.regionId - 1]" :key="index" :value="area.id.toString()">{{ area.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </transition>
            </fieldset>
            <fieldset class="fieldset-reset form-main-fieldset">
              <div class="form-main-label">
                <label class="create-item-label" for="images">Bilder</label>
                <span class="form-main-label-error" v-show="errors.images">{{ errors.images }}</span>
              </div>
              <div class="form-main-input">
                <div class="image-preview-wrapper">
                  <ImagePreview class="image-preview-item" v-for="index in 6" :key="index" :index="index - 1" :disableClick="index - form.images.length > 1" :resetPreview="resetPreview" v-model="form.images[index - 1]" @input-error="handleImageError"></ImagePreview>
                </div>
              </div>
            </fieldset>
            <fieldset class="fieldset-reset form-main-fieldset">
              <div class="form-main-label">
                <label for="name">Namn</label>
                <span class="form-main-label-error" v-show="errors.name">{{ errors.name }}</span>
              </div>
              <div class="form-main-input">
                <input type="text" id="name" maxlength="50" :class="{ error: errors.name }" v-model.trim="form.name">
              </div>
              <div class="form-main-label">
                <label for="email">Epost</label>
                <span class="form-main-label-error" v-show="errors.email">{{ errors.email }}</span>
              </div>
              <div class="form-main-input">
                <input type="email" id="email" maxlength="100" autocorrect="off" autocapitalize="off" :class="{ error: errors.email }" v-model.trim="form.email">
              </div>
              <div class="form-main-label">
                <label for="phone">Telefon</label>
                <span class="form-main-label-info">(Frivilligt, visas i annonsen)</span>
                <span class="form-main-label-error" v-show="errors.phone">{{ errors.phone }}</span>
              </div>
              <div class="form-main-input">
                <input type="tel" id="phone" maxlength="20" :class="{ error: errors.phone }" v-model.trim="form.phone">
              </div>
            </fieldset>
            <fieldset class="fieldset-reset form-main-fieldset">
              <button class="button-reset button-base button-primary form-main-submit-button" type="submit" :class="{ 'button-primary-active': posting }" :disabled="posting">
                <i class="fas fa-marker"></i><i v-if="posting">Ett ögonblick...</i><span v-else>Skapa annons</span>
              </button>
            </fieldset>
          </form>
        </div>
      </div>
    </main>
    <FooterMain></FooterMain>
  </div>
</template>

<script>
import axios from 'axios'
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'
import ImagePreview from '@/components/ImagePreview.vue'
import ModalSuccessItemCreate from '@/components/modals/SuccessItemCreate.vue'
import { minLength, isNumeric, validEmail, validPhone } from '@/library/form-validators.js'
import categories from '@/data/categories.json'
import subcategories from '@/data/subcategories.json'
import regions from '@/data/regions.json'
import areas from '@/data/areas.json'

export default {
  name: 'ItemCreate',
  components: {
    HeaderMain,
    FooterMain,
    ImagePreview,
    ModalSuccessItemCreate
  },
  data () {
    return {
      categories: categories,
      subcategories: subcategories,
      regions: regions,
      areas: areas,
      resetPreview: false,
      showModalSuccessItemCreate: false,
      posting: false,
      responseError: false,
      errors: {},
      form: {
        title: '',
        description: '',
        price: '',
        subcategoryId: '',
        regionId: '',
        areaId: '',
        name: '',
        email: '',
        phone: '',
        images: []
      }
    }
  },
  methods: {
    resetForm () {
      this.resetPreview = true
      this.form.title = ''
      this.form.description = ''
      this.form.price = ''
      this.form.subcategoryId = ''
      this.form.regionId = ''
      this.form.areaId = ''
      this.form.name = ''
      this.form.email = ''
      this.form.phone = '',
      this.form.images = []
    },
    handleImageError (error) {
      this.$set(this.errors, 'images', error)
    },
    validate () {
      this.resetPreview = false
      this.responseError = false
      this.errors = {}

      this.form.price = this.form.price.replace(/\s+/g, '')

      if (!minLength(this.form.title, 1)) {
        this.$set(this.errors, 'title', 'Skriv en rubrik')
      }
      if (!minLength(this.form.description, 1)) {
        this.$set(this.errors, 'description', 'Skriv lite om produkten/föremålet')
      }
      if (!minLength(this.form.price, 1)) {
        this.$set(this.errors, 'price', 'Ange ett pris')
      }
      else if (!isNumeric(this.form.price)) {
        this.$set(this.errors, 'price', 'Pris får endast innehålla siffror')
      }
      if (!minLength(this.form.subcategoryId, 1)) {
        this.$set(this.errors, 'subcategoryId', 'Välj en kategori')
      }
      if (!minLength(this.form.regionId, 1)) {
        this.$set(this.errors, 'regionId', 'Välj län')
      }
      if (!minLength(this.form.areaId, 1) && this.form.regionId != 3) {
        this.$set(this.errors, 'areaId', 'Välj kommun')
      }
      if (!minLength(this.form.name, 1)) {
        this.$set(this.errors, 'name', 'Namn saknas')
      }
      if (!minLength(this.form.email, 1)) {
        this.$set(this.errors, 'email', 'Epostadress saknas')
      } else if (!validEmail(this.form.email)) {
        this.$set(this.errors, 'email', 'Epostadressen har ogiltigt format')
      }
      if (!validPhone(this.form.phone)) {
        this.$set(this.errors, 'phone', 'Telefonnumret har ogiltigt format')
      }

      if (!Object.keys(this.errors).length) {
        this.submit()
      } else {
        window.scrollTo(0, 0)
      }
    },
    submit () {
      this.posting = true

      let formData = new FormData()

      for (let i = 0; i < this.form.images.length; i++) {
        formData.append('images[]', this.form.images[i])
      }

      formData.append('title', this.form.title)
      formData.append('description', this.form.description)
      formData.append('price', this.form.price)
      formData.append('subcategoryId', this.form.subcategoryId)
      formData.append('regionId', this.form.regionId)
      formData.append('areaId', this.form.areaId)
      formData.append('name', this.form.name)
      formData.append('email', this.form.email)
      formData.append('phone', this.form.phone)

      axios.post(process.env.VUE_APP_API_ENDPOINT + '/items', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(() => {
        window.scrollTo(0, 0)
        this.resetForm()
        this.posting = false
        this.showModalSuccessItemCreate = true
      })
      .catch(() => {
        window.scrollTo(0, 0)
        this.posting = false
        this.responseError = true
      })
    }
  },
  watch: {
    'form.title' () {
      if (this.errors.title) {
        this.$delete(this.errors, 'title')
      }
    },
    'form.description' () {
      if (this.errors.description) {
        this.$delete(this.errors, 'description')
      }
    },
    'form.price' () {
      if (this.errors.price) {
        this.$delete(this.errors, 'price')
      }
    },
    'form.subcategoryId' () {
      if (this.errors.subcategoryId) {
        this.$delete(this.errors, 'subcategoryId')
      }
    },
    'form.regionId' () {
      this.form.areaId = ''
      if (this.errors.regionId) {
        this.$delete(this.errors, 'regionId')
      }
      if (this.errors.areaId) {
        this.$delete(this.errors, 'areaId')
      }
    },
    'form.areaId' () {
      if (this.errors.areaId) {
        this.$delete(this.errors, 'areaId')
      }
    },
    'form.name' () {
      if (this.errors.name) {
        this.$delete(this.errors, 'name')
      }
    },
    'form.email' () {
      if (this.errors.email) {
        this.$delete(this.errors, 'email')
      }
    },
    'form.phone' () {
      if (this.errors.phone) {
        this.$delete(this.errors, 'phone')
      }
    },
    'form.images' () {
      if (this.errors.images) {
        this.$delete(this.errors, 'images')
      }
    }
  },
  mounted () {
    document.title = 'Gluo - Skapa ny annons'
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_breakpoints.scss';
@import '@/assets/scss/modules/_variables.scss';

.image-preview-wrapper {
  margin: -6px;
  display: flex;
  flex-wrap: wrap;
}

.image-preview-item {
  margin: 6px;
}
</style>
